/* Pokéled — interactions accueil (port vanilla de Pokeled.dc.html) */
(function () {
  'use strict';

  /* Header : rétrécit le logo après 50px de scroll */
  var scrolled = false;
  function onScrollHeader() {
    var y = window.scrollY || window.pageYOffset || 0;
    var v = y > 50;
    if (v !== scrolled) {
      scrolled = v;
      document.documentElement.classList.toggle('pk-scrolled', v);
    }
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Menu burger mobile : ouvert/fermé via classe (le menu est hors du header
       filtré pour que position:fixed couvre bien tout l'écran) */
    var burger = document.getElementById('pk-burger');
    var mobnav = document.getElementById('pk-mobnav');
    var mobclose = document.getElementById('pk-mobclose');
    var openNav = function () { if (mobnav) { mobnav.classList.add('pk-open'); document.documentElement.style.overflow = 'hidden'; } };
    var closeNav = function () { if (mobnav) { mobnav.classList.remove('pk-open'); document.documentElement.style.overflow = ''; } };
    if (burger) burger.addEventListener('click', openNav);
    if (mobclose) mobclose.addEventListener('click', closeNav);
    if (mobnav) {
      mobnav.addEventListener('click', function (e) {
        if (e.target.tagName === 'A') closeNav();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

    /* Parallaxe douce de la carte bannière */
    var card = document.getElementById('pk-banner-card');
    if (card) {
      var onParallax = function () {
        var p = Math.min(1, Math.max(0, (window.scrollY || 0) / 600));
        card.style.transform = 'translateY(' + (p * -22) + 'px)';
      };
      window.addEventListener('scroll', onParallax, { passive: true });
      onParallax();
    }

    /* Compteurs animés */
    var counters = document.querySelectorAll('.pk-count');
    var runCounter = function (el) {
      var to = parseFloat(el.getAttribute('data-to'));
      if (isNaN(to)) return;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var suf = el.getAttribute('data-suffix') || '';
      var dur = 1400;
      var t0 = performance.now();
      var fmt = function (v) {
        return (dec ? v.toFixed(dec).replace('.', ',') : Math.round(v).toString()) + suf;
      };
      var step = function (now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(to * e);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(to);
      };
      el.textContent = fmt(0);
      requestAnimationFrame(step);
    };
    if (counters.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { runCounter(en.target); obs.unobserve(en.target); }
          });
        }, { threshold: 0.4 });
        counters.forEach(function (el) { io.observe(el); });
      } else {
        counters.forEach(runCounter);
      }
    }

    /* Slider avant / après */
    var cmp = document.getElementById('pk-compare');
    var after = document.getElementById('pk-compare-after');
    var handle = document.getElementById('pk-compare-handle');
    if (cmp && after && handle) {
      var dragging = false;
      var setPos = function (clientX) {
        var r = cmp.getBoundingClientRect();
        var p = ((clientX - r.left) / r.width) * 100;
        p = Math.max(2, Math.min(98, p));
        after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        handle.style.left = p + '%';
      };
      cmp.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { cmp.setPointerCapture(e.pointerId); } catch (x) {}
        setPos(e.clientX);
      });
      cmp.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
      var stop = function () { dragging = false; };
      cmp.addEventListener('pointerup', stop);
      cmp.addEventListener('pointerleave', stop);
    }

    /* Carrousel d'avis : défile d'une "page" (largeur visible) */
    var track = document.getElementById('pk-rev-track');
    var prev = document.getElementById('pk-rev-prev');
    var next = document.getElementById('pk-rev-next');
    if (track && prev && next) {
      var page = function (dir) {
        var amount = track.clientWidth * 0.9;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
    }

    /* Avis : "voir plus" (clamp) + lightbox photos — délégation, valable sur toutes les pages */
    document.addEventListener('click', function (e) {
      var openb = e.target.closest ? e.target.closest('.pk-revmodal-open') : null;
      if (openb) { var md = document.getElementById(openb.getAttribute('data-revmodal')); if (md) md.classList.add('pk-open'); return; }
      var clb = e.target.closest ? e.target.closest('.pk-revmodal-close') : null;
      if (clb) { var mm = clb.closest('.pk-revmodal'); if (mm) mm.classList.remove('pk-open'); return; }
      if (e.target.classList && e.target.classList.contains('pk-revmodal')) { e.target.classList.remove('pk-open'); return; }
      var more = e.target.closest ? e.target.closest('.pk-revmore') : null;
      if (more) {
        var tx = more.previousElementSibling;
        if (tx && tx.classList.contains('pk-revtext')) {
          var clamped = tx.classList.toggle('pk-clamp');
          more.textContent = clamped ? 'Voir plus' : 'Voir moins';
        }
        return;
      }
      var pic = e.target.closest ? e.target.closest('.pk-revimg') : null;
      if (pic) {
        var src = pic.getAttribute('data-full') || pic.src;
        var lb = document.getElementById('pk-lightbox');
        if (!lb) {
          lb = document.createElement('div'); lb.id = 'pk-lightbox'; lb.className = 'pk-lightbox';
          lb.innerHTML = '<button class="pk-lb-close" aria-label="Fermer">×</button><img alt="Photo d\'avis">';
          document.body.appendChild(lb);
          lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target.classList.contains('pk-lb-close')) lb.classList.remove('pk-open'); });
        }
        lb.querySelector('img').src = src; lb.classList.add('pk-open');
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var lb = document.getElementById('pk-lightbox'); if (lb) lb.classList.remove('pk-open'); document.querySelectorAll('.pk-revmodal.pk-open').forEach(function (m) { m.classList.remove('pk-open'); }); } });

    /* Apparition au scroll (.pk-reveal -> .pk-in), avec léger décalage en cascade */
    var reveals = document.querySelectorAll('.pk-reveal');
    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        var rObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              var sibs = en.target.parentNode ? en.target.parentNode.querySelectorAll(':scope > .pk-reveal') : [en.target];
              var i = Array.prototype.indexOf.call(sibs, en.target);
              en.target.style.transitionDelay = (i > 0 ? (i % 5) * 0.08 : 0) + 's';
              en.target.classList.add('pk-in');
              rObs.unobserve(en.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach(function (el) { rObs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('pk-in'); });
      }
    }
  });
})();
